import React from 'react';
import { useTranslation } from 'next-i18next';
import { Menu, MenuItem } from '@mui/material';
import { QueueMusicRounded } from '@mui/icons-material';

import PlaylistMenu from '@/components/playlist/menu';
import { Playlist } from '@/infrastructure/class/playlist';
import { AudioSurah } from '@/infrastructure/class/audio-surah';
import { useAuth } from '@/infrastructure/context/auth-context';
import { usePlaylist } from '@/infrastructure/context/playlist-context';

interface IAddToPlaylistMenuItemProps {
  audioSurah: AudioSurah;
  currentPlaylist?: Playlist;
  onClose?: () => void;
}

const AddToPlaylistMenuItem: React.FC<IAddToPlaylistMenuItemProps> = (
  props
) => {
  const { audioSurah, currentPlaylist, onClose = () => {} } = props;
  const { addToPlaylist, removeFromPlaylist } = usePlaylist();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { t: tButtons } = useTranslation('buttons');

  const { authUser, checkAuth, showMessage } = useAuth();

  const handleOpen = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    onClose();
  };
  const handlePlaylistClick = async (playlist: Playlist) => {
    await checkAuth();
    if (authUser) {
      showMessage(tButtons('addedToPlaylist'));
      await addToPlaylist({
        user: authUser,
        audioSurah,
        playlistId: playlist.id,
      });
      onClose();
      handleClose();
    }
  };
  const handleDeleteFromPlaylist = async () => {
    if (authUser && currentPlaylist) {
      showMessage(tButtons('removedFromPlaylist'));
      await removeFromPlaylist({
        user: authUser,
        audioSurah,
        playlistId: currentPlaylist.id,
      });
    }
  };

  return currentPlaylist ? (
    <MenuItem onClick={handleDeleteFromPlaylist}>
      <i>
        <QueueMusicRounded />
      </i>
      <span>{tButtons('removeFromPlaylist')}</span>
    </MenuItem>
  ) : (
    <>
      <MenuItem onClick={handleOpen}>
        <i>
          <QueueMusicRounded />
        </i>
        <span>{tButtons('addToAPlaylist')}</span>
      </MenuItem>
      <Menu
        anchorEl={anchorEl}
        open={open}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
      >
        <PlaylistMenu
          onItemClick={handlePlaylistClick}
          handleClose={handleClose}
        />
      </Menu>
    </>
  );
};

export default AddToPlaylistMenuItem;
